var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDockLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95964 3.33301C2.69398 3.33301 1.66797 4.35902 1.66797 5.62467V14.3747C1.66797 15.6403 2.69398 16.6663 3.95964 16.6663H16.043C17.3086 16.6663 18.3346 15.6403 18.3346 14.3747V5.62467C18.3346 4.35902 17.3086 3.33301 16.043 3.33301H3.95964ZM2.91797 5.62467C2.91797 5.04938 3.38434 4.58301 3.95964 4.58301H6.67153V15.4163H3.95964C3.38434 15.4163 2.91797 14.95 2.91797 14.3747V5.62467ZM7.92153 15.4163H16.043C16.6183 15.4163 17.0846 14.95 17.0846 14.3747V5.62467C17.0846 5.04938 16.6183 4.58301 16.043 4.58301H7.92153V15.4163Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockLeft);
export default __webpack_public_path__ + "static/media/dock_left.c0d91a546a4ebdb9a7216ac6e81cf135.svg";
export { ForwardRef as ReactComponent };